import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      backgroundColor: '#f8fafc',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        padding: '48px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px'
          }}>
            <img
              src="/execdash_logo.png"
              alt="ExecDash Logo"
              style={{
                height: '48px',
                width: 'auto'
              }}
            />
          </div>
          <h1 style={{
            fontSize: '36px',
            fontWeight: 300,
            color: '#1a202c',
            margin: '0 0 16px 0',
            fontFamily: 'Raleway, sans-serif'
          }}>
            Terms and Conditions
          </h1>
          <p style={{
            color: '#718096',
            fontSize: '16px',
            margin: 0
          }}>
            Last updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* Content */}
        <div style={{
          lineHeight: '1.7',
          color: '#2d3748',
          fontSize: '16px'
        }}>
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              1. Acceptance of Terms
            </h2>
            <p style={{ marginBottom: '16px' }}>
              By accessing and using Execdash ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              2. Description of Service
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Execdash is an executive dashboard platform that provides business intelligence and analytics services. The Service allows users to connect their business systems, visualize data, and generate AI-powered insights for executive decision-making.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              3. User Accounts and Registration
            </h2>
            <p style={{ marginBottom: '16px' }}>
              To access certain features of the Service, you must register for an account. You agree to:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Provide accurate, current, and complete information during registration</li>
              <li style={{ marginBottom: '8px' }}>Maintain and update your information to keep it accurate and current</li>
              <li style={{ marginBottom: '8px' }}>Keep your password secure and confidential</li>
              <li style={{ marginBottom: '8px' }}>Accept responsibility for all activities under your account</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              4. Data Privacy and Security
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We take your data privacy seriously. By using our Service, you acknowledge that:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>We collect and process data as described in our Privacy Policy</li>
              <li style={{ marginBottom: '8px' }}>We implement industry-standard security measures to protect your data</li>
              <li style={{ marginBottom: '8px' }}>You retain ownership of your business data</li>
              <li style={{ marginBottom: '8px' }}>We may use aggregated, anonymized data for service improvement</li>
            </ul>
            <p style={{ marginBottom: '24px' }}>
              We implement appropriate technical and organizational measures to protect personal data against unauthorized or unlawful processing, accidental loss, destruction, or damage.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              5. Data Storage and International Transfers
            </h2>
            <p style={{ marginBottom: '16px' }}>
              All data collected through our Service is securely stored in Microsoft Azure's UK South region. By using our Service, you acknowledge and consent to the storage and processing of your data in the United Kingdom.
            </p>
            <p style={{ marginBottom: '16px' }}>
              We maintain appropriate safeguards to ensure that your personal data receives an adequate level of protection regardless of where it is processed. These safeguards include implementing standard contractual clauses where required by applicable data protection laws.
            </p>
            <p style={{ marginBottom: '16px' }}>
              We will not transfer your personal data outside of the UK unless we have taken steps to ensure that your data will be afforded the same level of protection as required under UK data protection laws.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              6. Acceptable Use
            </h2>
            <p style={{ marginBottom: '16px' }}>
              You agree not to use the Service to:
            </p>
            <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Violate any applicable laws or regulations</li>
              <li style={{ marginBottom: '8px' }}>Infringe on intellectual property rights</li>
              <li style={{ marginBottom: '8px' }}>Transmit malicious code or attempt to gain unauthorized access</li>
              <li style={{ marginBottom: '8px' }}>Interfere with or disrupt the Service or servers</li>
              <li style={{ marginBottom: '8px' }}>Use the Service for any unlawful or prohibited purpose</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              7. Service Availability
            </h2>
            <p style={{ marginBottom: '16px' }}>
              While we strive to maintain high availability, we do not guarantee that the Service will be available at all times. We may suspend or terminate the Service for maintenance, updates, or other operational reasons with reasonable notice when possible.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              8. Intellectual Property
            </h2>
            <p style={{ marginBottom: '16px' }}>
              The Service and its original content, features, and functionality are owned by Execdash and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              9. Limitation of Liability
            </h2>
            <p style={{ marginBottom: '16px' }}>
              In no event shall ExecDash be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              10. Termination
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              11. Changes to Terms
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the Service. Your continued use of the Service after such modifications constitutes acceptance of the updated terms.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1a202c',
              marginBottom: '16px'
            }}>
              12. Contact Information
            </h2>
            <p style={{ marginBottom: '16px' }}>
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <p style={{ marginBottom: '8px' }}>
              <strong>Email:</strong> support@execdash.ai
            </p>
          </section>
        </div>


      </div>
    </div>
  );
};

export default TermsAndConditions;
